import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { ProgressBar, Text } from 'react-native-paper'
import { FontsEnum } from '../../../constants/fonts'

interface ProgressBarWithQuantityProps {
    readyQuantity: number
    totalQuantity: number
    color: string
}

const ProgressBarWithQuantity: FC<ProgressBarWithQuantityProps> = ({
    readyQuantity,
    totalQuantity,
    color,
}) => {
    return (
        <View>
            <Text style={[styles.text, { color }]}>
                {readyQuantity}/{totalQuantity}
            </Text>
            <ProgressBar
                progress={readyQuantity / totalQuantity}
                color={color}
                style={styles.bar}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    text: {
        fontFamily: FontsEnum.RUBIK_500_MEDIUM,
        fontSize: 18,
        textAlign: 'center',
        marginBottom: 4,
    },
    bar: {
        height: 6,
        width: 44,
    },
})

export default ProgressBarWithQuantity
